import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import AnswerTitle from "./components/Title"
import AnswerLabel from "./components/Label"
import AnswerDescription from "./components/Description"
import AnswerEdit from "./components/Edit"

const Answer = ({ children, className }) => {
  return <div className={["answer", className].join(" ")}>{children}</div>
}

Answer.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  className: propTypes.string
}

Answer.defaultProps = {
  className: ""
}

export { AnswerTitle, AnswerLabel, AnswerDescription, AnswerEdit }

export default Answer
